/**
 * Button Component
 * Reusable CTA button with primary/secondary variants
 */
export function Button({
  children,
  variant = "primary",
  hero = false,
  mobileOnly = false,
  className = "",
  href,
  ...props
}) {
  const baseStyles = `
    inline-flex items-center justify-center
    px-8 py-4 rounded-[88rem]
    text-[1.05rem] font-[480] text-center
    transition-all duration-200
    hover:-translate-y-0.5 active:translate-y-0
  `;

  const variants = {
    primary: hero ? "bg-secondary text-green" : "bg-green text-white",
    secondary: hero
      ? "glass-light border border-white/[0.03] text-white hover:bg-white/15"
      : "bg-green text-white",
  };

  const mobileOnlyStyles = mobileOnly
    ? "hidden max-md:inline-flex max-md:w-full max-md:mt-4"
    : "";

  const combinedClassName = `
    ${baseStyles}
    ${variants[variant]}
    ${mobileOnlyStyles}
    ${className}
  `.trim();

  if (href) {
    return (
      <a href={href} className={combinedClassName} {...props}>
        {children}
      </a>
    );
  }

  return (
    <button className={combinedClassName} {...props}>
      {children}
    </button>
  );
}

export default Button;
